declare namespace $ {

	type $shm_button_copy__text_shm_hitalama_text_code_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text_code['text_export'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $shm_hitalama_text_rows__render_visible_only_shm_hitalama_text_code_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text_code['render_visible_only'] >
		,
		ReturnType< $shm_hitalama_text_rows['render_visible_only'] >
	>
	type $shm_hitalama_text_rows__rows_shm_hitalama_text_code_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text_code['rows'] >
		,
		ReturnType< $shm_hitalama_text_rows['rows'] >
	>
	export class $shm_hitalama_text_code extends $mol_text_code {
		Copy_button( ): $shm_button_copy
		render_visible_only( ): boolean
		Rows( ): $shm_hitalama_text_rows
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=code.view.tree.d.ts.map